(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["catalog-form-html"] && !Shopify.designMode) return;
  try {
    jQuery(document).ready(function ($) {
    $('form.catalog-form').on('submit', function (e2) {
      // alert('what!');
      e2.preventDefault();
      // var $recaptcha = $(this).find('.g-recaptcha');
      // if ($recaptcha.length && window.not_robot === false) {
      //   return false;
      // }
      var $form = $(this);
      var action = this.dataset.action;
      if (!action) return null;
      $.ajax({
        method: 'POST',
        url: action,
        data: $(this).serialize(),
      }).done(function (response) {
        if (response.status === 'success') {
          var msg = $('.form-row__newsletter_result').data('success');
          $('.form-row__newsletter_result').html(msg).show();
          $form.trigger('reset');
        } else {
          $('.form-row__newsletter_result').html(response.status).show();
        }
      });
      return false;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-float"] && !Shopify.designMode) return;
  try {
    jQuery(document).ready(function ($) {
    const $float = $('.pdp-buyflow__float');
    const $actions = $('.product__actions .action--atc .btn--atc');

    function checkVisibility() {
      if ($actions.length === 0) return; // safety check

      const windowTop = $(window).scrollTop();
      const windowBottom = windowTop + $(window).height();
      const headerHeight = $('.fixed-wrap').innerHeight() || 0;

      const actionsTop = $actions.offset().top;
      const actionsBottom = actionsTop + $actions.outerHeight();

      // visible = any part of the button is on screen, below the fixed header
      const isVisible = actionsBottom > (windowTop + headerHeight) && actionsTop < windowBottom;

      if (isVisible) {
        $float.removeClass('is-active');
      } else {
        $float.addClass('is-active');
      }
    }

    // run on scroll and resize
    $(window).on('scroll resize', checkVisibility);
    checkVisibility();

    $('.pdp-buyflow__float button').on('click', function (e) {
      e.preventDefault();
      $(this).find('.loader').css('opacity', 1);
      $('#product-form').trigger('submit');

      //$('#product-form .product__actions .action--atc button').click();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
